/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { OrganizationStrictHttpResponse } from '../../organization-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { OrganizationSearchModel } from '../../models/organization-search-model';
import { OrganizationSearchResultModel } from '../../models/organization-search-result-model';

export interface AdminSearchOrganizationPost$Params {
      body?: OrganizationSearchModel
}

export function adminSearchOrganizationPost(http: HttpClient, rootUrl: string, params?: AdminSearchOrganizationPost$Params, context?: HttpContext): Observable<OrganizationStrictHttpResponse<Array<OrganizationSearchResultModel>>> {
  const rb = new RequestBuilder(rootUrl, adminSearchOrganizationPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as OrganizationStrictHttpResponse<Array<OrganizationSearchResultModel>>;
    })
  );
}

adminSearchOrganizationPost.PATH = '/Admin/SearchOrganization';
